var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "modal-dialog modal-fullscreen code-mirror-modal" },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-header d-flex py-1" }, [
          _c("h4", {
            staticClass: "modal-title flex-fill fs-6",
            domProps: { innerHTML: _vm._s(_setup.modalTitle) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c("div", { staticClass: "dropdown" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "dropdown-menu dropdown-menu-end",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c(
                    "li",
                    { staticClass: "dropdown-item text-center" },
                    [_c(_setup.CodemirrorModeMenu)],
                    1
                  ),
                  _vm._v(" "),
                  _c(_setup.CodemirrorLineNumbersBtn),
                  _vm._v(" "),
                  _c(_setup.CodemirrorLineWrappingBtn),
                  _vm._v(" "),
                  _setup.showTwigControl
                    ? _c(_setup.CodemirrorTwigModeBtn)
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn-close ms-2",
              attrs: { "aria-label": "Close", type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("hide-modal")
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-body p-0 h-100" }, [
          _c("textarea", { ref: "codeMirrorTextArea" }, [
            _vm._v(_vm._s(_setup.value)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-footer py-1" }, [
          !_setup.readOnly
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm d-flex align-items-center",
                  class: {
                    "btn-light": !_setup.changesExist,
                    "btn-warning": _setup.changesExist,
                  },
                  attrs: {
                    disabled: !_setup.changesExist || !_setup.idExists,
                    type: "button",
                  },
                  on: { click: _setup.saveChanges },
                },
                [_vm._v("\n                Save\n            ")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.readOnly
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm",
                  class: {
                    "btn-light": !_setup.changesExist,
                    "btn-warning": _setup.changesExist,
                  },
                  attrs: { type: "button" },
                  on: { click: _setup.saveChangesAndCloseModal },
                },
                [_vm._v("\n                Close\n            ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.changesExist
            ? _c(
                "button",
                {
                  staticClass: "btn btn-light btn-sm modal-discard-changes",
                  attrs: { type: "button" },
                  on: { click: _setup.discardChanges },
                },
                [_vm._v("\n                Discard changes\n            ")]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "btn btn-sm btn-light",
        attrs: { "data-bs-toggle": "dropdown", type: "button" },
      },
      [_c("i", { staticClass: "bi-three-dots" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }